import {useEffect} from "react";
import {useLocation} from "react-router-dom";

// Utility function to scroll to top - can be used anywhere in the app
export const scrollToTop = () => {
    // Scroll the main window to top
    window.scrollTo(0, 0);
    
    // Also scroll the dashboard content container to top if it exists
    const dashboardScrollable = document.querySelector('.dashboard-content-scrollable');
    if (dashboardScrollable) {
        dashboardScrollable.scrollTo(0, 0);
    }
};

export default function ScrollToTop({ children }: { children: React.ReactNode }) {
    const { pathname } = useLocation();

    useEffect(() => {
        const canControlScrollRestoration = 'scrollRestoration' in window.history
        if (canControlScrollRestoration) {
            window.history.scrollRestoration = 'manual';
        }

        scrollToTop();
    }, [pathname]);

    return <>{children}</>;
}